import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import getAuth for authentication
import { getFirestore } from "firebase/firestore";  // Import Firestore for db
import { getStorage } from "firebase/storage";  // Optional, if you're using storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCrVZ6LoO7X8df9jtx6wgDD7zMCiC1APgM",
  authDomain: "kingdom-optical.firebaseapp.com",
  projectId: "kingdom-optical",
  storageBucket: "kingdom-optical.firebasestorage.app",
  messagingSenderId: "1054523284704",
  appId: "1:1054523284704:web:b53460812d14b69dd74485"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);  // Initialize Firebase Authentication
const db = getFirestore(app);  // Initialize Firestore
const storage = getStorage(app);  // Initialize Firebase Storage (if needed)

export { auth, db, storage };